import React from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';

interface SectionSaveButtonsProps {
  hasChanges: boolean;
  saving: boolean;
  onSave: () => void;
  onDiscard: () => void;
  disabled?: boolean;
  showUnsavedMessage?: boolean;
  hideWhenNoChanges?: boolean;
}

export const SectionSaveButtons: React.FC<SectionSaveButtonsProps> = ({
  hasChanges,
  saving,
  onSave,
  onDiscard,
  disabled = false,
  showUnsavedMessage = true,
  hideWhenNoChanges = true,
}) => {
  // If hideWhenNoChanges is true and there are no changes, hide the entire component
  if (hideWhenNoChanges && !hasChanges && !saving) {
    return null;
  }

  return (
    <Box sx={{ mt: 2, display: 'flex', gap: 2, alignItems: 'center' }}>
      <Button
        variant="contained"
        onClick={onSave}
        disabled={!hasChanges || saving || disabled}
        size="small"
      >
        {saving ? <CircularProgress size={16} /> : 'Save'}
      </Button>

      <Button
        variant="outlined"
        onClick={onDiscard}
        disabled={!hasChanges || saving || disabled}
        size="small"
      >
        Discard
      </Button>

      {hasChanges && showUnsavedMessage && (
        <Typography
          variant="body2"
          color="warning.main"
          sx={{ fontSize: '0.75rem' }}
        >
          Unsaved changes
        </Typography>
      )}
    </Box>
  );
};
